export const dateToIsoString = (d: Date) => d.toISOString();
export const nullToUndefined = <T>(v: T | null): T | undefined =>
  v ?? undefined;
